import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SuccessfulCheckIn } from '../models/public-token.model';
import { publicTokenLocal } from './public-token.local-storage';

interface PublicTokenState {
    saved?: string,
    all: SuccessfulCheckIn[],
    active?: SuccessfulCheckIn | undefined
}

const initialState: PublicTokenState = {
    saved: publicTokenLocal.getSavedValue() || undefined,
    all: publicTokenLocal.getSuccessfulCheckIns(),
};
publicTokenLocal.cleanup();

export const publicTokenSlice = createSlice({
    initialState,
    name: 'publicToken',
    reducers: {
        setActiveSuccessful(state, action: PayloadAction<SuccessfulCheckIn | undefined>) {
            state.active = action.payload;
        },
        setPublicCheckInValue(state, action: PayloadAction<{ value: string }>) {
            state.saved = action.payload.value;
        },
        clearPublicCheckInSuccessfulIds(state) {
            state.all = [];
        },
    },
});

export const { setPublicCheckInValue, clearPublicCheckInSuccessfulIds, setActiveSuccessful } = publicTokenSlice.actions;
